<template>
  <article class="project">
    <a class="project-link" :href="project.url">
      View Project
    </a>
    <div class="project-image">
      <img :src="project.photos[0].url" alt="">
    </div>
    <div class="project-text">
      <h1 class="project-name h5">{{ project.title }}</h1>
      <div class="project-company">
        <img class="project-company-logo" :src="project.company.logo" />
        <div class="project-company-info">
          <h3 class="project-company-name">{{ project.company.name }}</h3>
          <h3 class="project-company-location">{{ project.company.location }}</h3>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  props: {
    project: {
      type: Object
    }
  },

  data() {
    return {};
  },

  computed: {
  }
};
</script>

<style lang="scss" scoped>

.project {
  position: relative;
  padding: 1rem;
}
.project-link {
  display: block;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-indent: -9999px;
  border-radius: $radius_large;
  transition: all 0.2s $easeOutQuart;
  box-shadow: $box_shadow_0;
  z-index: 1;
  &:hover, &:focus {
    box-shadow: $box_shadow_50;
  }
}
.project-image {
  img {
    width: 100%;
    background-color: var(--bg-2);
    display: block;
  }
}
.project-company {
  display: flex;
  @extend %b2;
}
.project-name {
  margin-top: 0.5rem;
  margin-bottom: 0.75rem;
}
.project-company-logo {
  width: 2.5rem;
  height: 2.5rem;
  margin-right: 1rem;
  background-color: var(--bg-2);

  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
  border-radius: $radius_large;
}
.project-company-name {
  @extend %b2e;
}
.project-company-location {
  color: var(--fg-2);
}
</style>



// WEBPACK FOOTER //
// app/javascript/components/project-card.vue?74904856